import { render, staticRenderFns } from "./RegisterTeacherScheduleCard.vue?vue&type=template&id=0d73ecbc&scoped=true&"
import script from "./RegisterTeacherScheduleCard.vue?vue&type=script&lang=js&"
export * from "./RegisterTeacherScheduleCard.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTeacherScheduleCard.vue?vue&type=style&index=0&id=0d73ecbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d73ecbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VRow})
